import { render, staticRenderFns } from "./SwitchProfile.vue?vue&type=template&id=7d144e38&scoped=true&"
import script from "./SwitchProfile.vue?vue&type=script&lang=js&"
export * from "./SwitchProfile.vue?vue&type=script&lang=js&"
import style0 from "./SwitchProfile.vue?vue&type=style&index=0&id=7d144e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d144e38",
  null
  
)

export default component.exports